import { render, staticRenderFns } from "./LockPicture.vue?vue&type=template&id=08ab9609&scoped=true&"
import script from "./LockPicture.vue?vue&type=script&lang=js&"
export * from "./LockPicture.vue?vue&type=script&lang=js&"
import style0 from "./LockPicture.vue?vue&type=style&index=0&id=08ab9609&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab9609",
  null
  
)

export default component.exports